/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserBillingInformationCardBrandType = 'VISA' | 'JCB' | 'DINERS' | 'MASTER' | 'LOCAL' | 'AMEX' | 'UNIONPAY';

export const UserBillingInformationCardBrandType = {
    Visa: 'VISA' as UserBillingInformationCardBrandType,
    Jcb: 'JCB' as UserBillingInformationCardBrandType,
    Diners: 'DINERS' as UserBillingInformationCardBrandType,
    Master: 'MASTER' as UserBillingInformationCardBrandType,
    Local: 'LOCAL' as UserBillingInformationCardBrandType,
    Amex: 'AMEX' as UserBillingInformationCardBrandType,
    Unionpay: 'UNIONPAY' as UserBillingInformationCardBrandType
};

